import GalleryList from "./GalleryList";
import "./Gallery.css";

export default function GalleryPage() {
  return <GalleryList />;
}
